"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _transmission = _interopRequireDefault(require("cccisd-icons/transmission"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Boilerplate = window.cccisd.boilerplate;
var _default = exports["default"] = function _default(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    saving = _useState2[0],
    setSaving = _useState2[1];
  var data = props.data,
    closeModal = props.closeModal,
    loadData = props.loadData,
    actualValues = props.actualValues;
  var options = data[0].codes;
  var initialValues = function () {
    var result = {};
    options.forEach(function (option, index) {
      result["no_reverse_".concat(index)] = false;
      result["set_all_".concat(index)] = '';
    });
    var _iterator = _createForOfIteratorHelper(data),
      _step;
    try {
      var _loop = function _loop() {
        var row = _step.value;
        row.codes.forEach(function (code, index) {
          result["code_".concat(row.variableId, "_").concat(index)] = code.code;
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return result;
  }();
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values) {
      var variables;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setSaving(true);
            variables = data.map(function (item) {
              var lookup = {};
              item.codes.forEach(function (code, index) {
                lookup[code.label] = values["code_".concat(item.variableId, "_").concat(index)];
              });
              return {
                variableId: item.variableId,
                lookup: lookup
              };
            });
            _context.n = 1;
            return _cccisdAxios["default"].put(Boilerplate.route('api.metrics.variable.bulkUpdate'), {
              variables: variables
            });
          case 1:
            _context.n = 2;
            return loadData();
          case 2:
            closeModal();
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var renderForm = function renderForm(_ref2) {
    var handleSubmit = _ref2.handleSubmit,
      values = _ref2.values,
      setFieldValue = _ref2.setFieldValue;
    var renderSetAll = function renderSetAll() {
      if (data.length <= 1) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("tr", {
        className: _style["default"].setAllRow
      }, /*#__PURE__*/_react["default"].createElement("td", {
        colSpan: "2"
      }, "\xA0"), options.map(function (option, index) {
        return /*#__PURE__*/_react["default"].createElement("td", {
          key: index,
          className: _style["default"].field
        }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          name: "set_all_".concat(index),
          className: "form-control",
          autoComplete: "off"
        }));
      }), /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-info btn-block",
        type: "button",
        onClick: setAll
      }, "Set All")));
    };
    var setAll = function setAll() {
      options.forEach(function (option, index) {
        if (!values["set_all_".concat(index)]) {
          return;
        }
        var _iterator2 = _createForOfIteratorHelper(data),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var row = _step2.value;
            setFieldValue("code_".concat(row.variableId, "_").concat(index), values["set_all_".concat(index)]);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      });
    };
    var reverse = function reverse(variableId) {
      var left = 0;
      var right = options.length - 1;
      while (left < right) {
        if (values["no_reverse_".concat(left)]) {
          left++;
        } else if (values["no_reverse_".concat(right)]) {
          right--;
        } else {
          var leftValue = values["code_".concat(variableId, "_").concat(left)];
          var rightValue = values["code_".concat(variableId, "_").concat(right)];
          setFieldValue("code_".concat(variableId, "_").concat(left), rightValue);
          setFieldValue("code_".concat(variableId, "_").concat(right), leftValue);
          left++;
          right--;
        }
      }
    };
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].tableWrapper
    }, /*#__PURE__*/_react["default"].createElement("table", {
      className: 'table table-bordered table-condensed table-striped ' + _style["default"].table
    }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
      colSpan: "2"
    }, "Do Not Reverse"), options.map(function (option, index) {
      return /*#__PURE__*/_react["default"].createElement("th", {
        key: index,
        className: "text-center"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        type: "checkbox",
        name: "no_reverse_".concat(index)
      }));
    }), /*#__PURE__*/_react["default"].createElement("th", null, "\xA0")), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null, "Question"), /*#__PURE__*/_react["default"].createElement("th", null, "Variable"), options.map(function (option, index) {
      return /*#__PURE__*/_react["default"].createElement("th", {
        key: index,
        className: "text-center"
      }, option.label);
    }), /*#__PURE__*/_react["default"].createElement("th", null, "\xA0"))), /*#__PURE__*/_react["default"].createElement("tbody", null, data.length >= 5 && renderSetAll(), data.map(function (row, i) {
      return /*#__PURE__*/_react["default"].createElement("tr", {
        key: row.variableId,
        className: i === 0 ? _style["default"].firstRow : ''
      }, /*#__PURE__*/_react["default"].createElement("td", null, row.question), /*#__PURE__*/_react["default"].createElement("td", null, actualValues["variable".concat(row.variableId)] || row.variable), row.codes.map(function (code, index) {
        return /*#__PURE__*/_react["default"].createElement("td", {
          key: index,
          className: _style["default"].field
        }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          name: "code_".concat(row.variableId, "_").concat(index),
          className: "form-control",
          autoComplete: "off",
          style: {
            width: '7em'
          }
        }));
      }), /*#__PURE__*/_react["default"].createElement("td", {
        style: {
          width: '1px'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-primary btn-block",
        type: "button",
        onClick: function onClick() {
          return reverse(row.variableId);
        }
      }, /*#__PURE__*/_react["default"].createElement(_transmission["default"], {
        spaceRight: true
      }), "Reverse")));
    }), renderSetAll()))), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      type: "button",
      onClick: handleSubmit,
      className: "btn btn-primary",
      title: "Save",
      isLoading: saving
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    onSubmit: onSubmit,
    initialValues: initialValues,
    render: renderForm
  });
};